<template>
    <div>
        <b-form-row class="mb-2">
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Type</label>
                <b-form-select v-model="measureTypeValue" :options="measureTypeOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Aggregation</label>
                <b-form-select v-model="aggregationTypeValue" :options="aggregationTypeOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Max frequencies</label>
                <b-form-select v-model="maxFreqValue" :options="maxFreqOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Target group</label>
                <b-form-select v-model="targetGroup" :options="targetGroupRofOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2" class="d-flex">
                <b-button variant="primary" class="mt-auto" @click="$emit('onUpdateRoF')" size="sm"> <b-icon icon="arrow-repeat"></b-icon> Update </b-button>
            </b-col>
        </b-form-row>

        <b-form-row class="mb-2 mt-4 d-flex justify-content-center">
            <Spinner v-if="RoFStatus == 'LOADING'" />
            <div class="failedRequest" v-else-if="RoFStatus == 'FAILED'">
                Cannot return result due to a server error.
            </div>
            <div v-else-if="RoFStatus == 'LOADED'">
                <div v-if="$store.getters.getProgramsRoFQuery.hasAdjustedTime">
                    <label class="label-text">
                        Date adjusted to start date: {{ $store.getters.getProgramsRoFQuery.startDate }} and end date: {{ $store.getters.getProgramsRoFQuery.endDate }}
                    </label>
                </div>
                <b-table
                    class="text-left tablemainresultclass"
                    thead-class="stickyfancytableheader thtablesrofsameheight"
                    striped
                    bordered
                    dense
                    sort-icon-left
                    :small="true"
                    :no-local-sorting="true"
                    :fields="initialTableColumns"
                    :items="initialTableItem"
                    :head-variant="'dark'"
                >
                    <template v-slot:cell(channelNames)="row">
                        <div class="position-relative">
                            <div class="tdchanneltextwrapperclass">
                                <span>{{ row.item.channelNames }}</span>
                            </div>
                            <b-icon
                                v-if="JSON.stringify(firstChannelNames) !== JSON.stringify(channelNames)"
                                @click="expandOrCollapseChannels"
                                :icon="channelsExpanded ? 'dash-square' : 'plus-square'"
                                class="tdicon"
                                variant="primary"
                            ></b-icon>
                        </div>
                    </template>
                    <template v-slot:cell(titlecode)="row">
                        <div class="position-relative">
                            <div class="tdchanneltextwrapperclass">
                                <span>{{ row.item.titlecode }}</span>
                            </div>
                            <b-icon
                                @click="expandOrCollapseTitlecodes"
                                v-if="JSON.stringify(firstTitleCodes) !== JSON.stringify(titleCodes)"
                                :icon="titleCodesExpanded ? 'dash-square' : 'plus-square'"
                                class="tdicon"
                                variant="primary"
                            ></b-icon>
                        </div>
                    </template>
                </b-table>
                <b-button @click="showDetails" v-if="isShowDetailsBtnVisible" size="sm" variant="primary" class="mt-2">Show details</b-button>
                <label class="label-text float-left mt-2" v-if="showTableDetails">Number of records: {{ allRofRows.length }}</label>
                <b-table
                    v-if="showTableDetails"
                    class="text-left mt-4 tablemainresultclass"
                    thead-class="stickyfancytableheader thtablesrofsameheight"
                    striped
                    bordered
                    dense
                    sort-icon-left
                    :small="true"
                    :no-local-sorting="true"
                    :fields="roFColumns"
                    :items="allRofRows"
                    :head-variant="'dark'"
                >
                </b-table>
            </div>
        </b-form-row>
    </div>
</template>
<script>
import * as Mutations from "@/store/modules/programs/mutation-types"
import Spinner from "@/components/Shared/Spinner/Spinner"
import * as Helpers from "@/helpers/index.js"

export default {
    name: "ProgramReach",
    props: {
        tabIndex: Number,
        isShowDetailsBtnVisible: Boolean,
        exceededRecommendedPeriodLimit: Boolean,
        showTableDetails: Boolean,
    },
    components: {
        Spinner,
    },
    computed: {
        measureTypeValue: {
            get() {
                return this.$store.getters.getProgramsRoFQuery.measureType
            },
            set(newValue) {
                this.$store.commit(Mutations.setProgramsRoFQuery, {
                    ...this.$store.getters.getProgramsRoFQuery,
                    measureType: newValue,
                })
            },
        },
        aggregationTypeValue: {
            get() {
                return this.$store.getters.getProgramsRoFQuery.aggregationType
            },
            set(newValue) {
                this.$store.commit(Mutations.setProgramsRoFQuery, {
                    ...this.$store.getters.getProgramsRoFQuery,
                    aggregationType: newValue,
                })
            },
        },
        maxFreqValue: {
            get() {
                return this.$store.getters.getProgramsRoFQuery.maxFreq
            },
            set(newValue) {
                this.$store.commit(Mutations.setProgramsRoFQuery, {
                    ...this.$store.getters.getProgramsRoFQuery,
                    maxFreq: newValue,
                })
            },
        },
        targetGroup: {
            get() {
                return this.$store.getters.getProgramsRoFQuery.targetGroup
            },
            set(newValue) {
                this.$store.commit(Mutations.setProgramsRoFQuery, {
                    ...this.$store.getters.getProgramsRoFQuery,
                    targetGroup: newValue,
                })
            },
        },
        firstChannelNames() {
            return Helpers.takeElementsUpTo200Chars(
                [
                    ...new Set(
                        this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                            .filter(p => p.chosen)
                            .map(p => p.levelTwoPrograms)
                            .flat()
                            .map(p => p.providerName)
                    ),
                ].sort()
            )
        },
        channelNames() {
            return [
                ...new Set(
                    this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                        .filter(p => p.chosen)
                        .map(p => p.levelTwoPrograms)
                        .flat()
                        .map(p => p.providerName)
                ),
            ].sort()
        },
        firstTitleCodes() {
            return Helpers.takeElementsUpTo200Chars([...this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms.filter(p => p.chosen).map(p => p.titleCode)])
        },
        titleCodes() {
            return this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms.filter(p => p.chosen).map(p => p.titleCode)
        },
        RoFStatus() {
            // both must be loaded because we need data from both
            const RoFStatus = this.$store.getters.getProgramsRoFResults.status
            const analysisStatus = this.$store.getters.getProgramsResults.status
            if (analysisStatus != "LOADED") {
                return RoFStatus == "LOADED" ? analysisStatus : RoFStatus
            } else {
                return RoFStatus
            }
        },
        initialTableColumns() {
            return this.$store.getters.getProgramsRoFResults.tableData.initialTableColumns
        },
        initialTableItem() {
            return this.$store.getters.getProgramsRoFResults.tableData.initialTableItem
        },
        roFColumns() {
            return this.$store.getters.getProgramsRoFResults.tableData.roFColumns
        },
        allRofRows() {
            return this.$store.getters.getProgramsRoFResults.tableData.allRofRows
        },
        maxFreqOptions() {
            return this.$store.getters.getProgramsRoFMaxFreqOptions
        },
    },
    data() {
        return {
            measureTypeOptions: [
                {
                    text: "Absolute",
                    value: "absolute",
                },
                {
                    text: "Relative",
                    value: "relative",
                },
            ],
            aggregationTypeOptions: [
                {
                    text: "Actual",
                    value: "actual",
                },
                {
                    text: "Cumulative",
                    value: "cumulative",
                },
            ],
            targetGroupRofOptions: [],
            channelsExpanded: false,
            titleCodesExpanded: false,
            isConfigInitialized: false,
        }
    },
    watch: {
        async tabIndex(tabIndex) {
            if (tabIndex === 1 && this.isConfigInitialized) {
                await this.setupRofTab()
                this.$emit("onShowTableDetails", false)
                if (!this.exceededRecommendedPeriodLimit) this.$emit("onUpdateRoF")
            }
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.isConfigInitialized = true
    },
    methods: {
        showDetails() {
            this.$emit("onShowDetailsBtnVisible", false)
            this.$emit("onShowTableDetails", true)
        },
        expandOrCollapseChannels() {
            this.channelsExpanded = !this.channelsExpanded
            if (this.channelsExpanded) {
                this.initialTableItem[0].channelNames = [...this.channelNames].join(", ")
            } else {
                this.initialTableItem[0].channelNames = [...this.firstChannelNames].join(", ")
            }
        },
        expandOrCollapseTitlecodes() {
            this.titleCodesExpanded = !this.titleCodesExpanded
            if (this.titleCodesExpanded) {
                this.initialTableItem[0].titlecode = [...this.titleCodes].join(", ")
            } else {
                this.initialTableItem[0].titlecode = [...this.firstTitleCodes].join(", ")
            }
        },
        async setupRofTab() {
            this.titleCodesExpanded = false
            this.channelsExpanded = false
            let storedTargets = this.$store.getters.getProgramsQuery.target_group
            
            var genderFunc = group => group == "all" ? "A" : group == "female" ? "W" : "M";

            this.targetGroupRofOptions = [...new Set(storedTargets.map(m => `${genderFunc(m.group)}${m.age_from}-${m.age_to}` ))]
            this.$store.commit(Mutations.setProgramsRoFQuery, {
                ...this.$store.getters.getProgramsRoFQuery,
                targetGroup: this.targetGroupRofOptions[0],
            })
        },
    },
}
</script>
<style scoped>
::v-deep .tablemainresultclass th {
    font-size: 0.8rem;
    background-color: #337ab7 !important;
    border-color: #bfd5e8 !important;
    border-top: white;
    border-width: 2px 1px 2px 1px !important;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
}
.mx-datepicker {
    width: 100%;
}
select {
    height: 2rem;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    font-size: 0.875rem;
}
.tdchanneltextwrapperclass {
    padding-bottom: 1.5rem;
}
.tdicon {
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.2rem;
}
>>> .table tbody tr td {
    vertical-align: top;
}
.tdicon {
    cursor: pointer; /* Set cursor to hand */
}
>>> .targetgroupheaderwidth,
>>> .universeheaderwidth {
    width: 6rem;
}
>>> .thtablesrofsameheight {
    font-size: 0.8rem;
    line-height: 2.5;
}
</style>
